import moment from 'moment';

export default function MemberReceivablesCtrl($scope, WampCall, progressBar, $state, $anchorScroll, $mdMedia) {

  var uri = 'org.eggs.receivable_list';
  var vm = this;

  $scope.mdMedia = $mdMedia;

  var items = $scope.$createObservableFunction('refresh')
      .startWith('nothing')
      .do(function () {
        vm.trades = [];
        vm.loadingEgg = true;
        vm.noItems = false;
        progressBar.add(uri);
      })
      .flatMap(function () {
        return new WampCall(uri);
      })
      .do(function () {
        progressBar.remove(uri);
      });

  var s1 = items
      .safeApply($scope, function (trades) {
        vm.trades = trades;
        vm.lastUpdated = moment();

        if (trades.length === 0) {
          vm.noItems = true;
        }
        else {
          vm.loadingEgg = false;
        }
      })
      .subscribe(
          function () {
            if ($state.params.id) {
              $anchorScroll('trade' + $state.params.id);
            }
          },
          function ($e) {
            vm.noItems = true;
            progressBar.remove(uri);
          });

  $scope.$on('$destroy', function () {
    s1.dispose();
    progressBar.remove(uri);
  });
}
